/** ----------------------------------------
    Module Interface
 ---------------------------------------- */

import module from './interface';

/** ----------------------------------------
    State
 ---------------------------------------- */

const actions = {
    setMenu({ commit }: any, payload: any) {
        commit('setMenu', payload);
    },

    setLang({ commit }: any, payload: any) {
        commit('changeLang', payload);
    },

    setInit({ commit }: any, payload: any) {
        commit('changeInit', payload);
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default actions;